import React, { useId, useState } from "react";
import { Button, Checkbox, ListItemText, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { tableFilterButtonSx } from "./tableFilterStyles";

const MultiSelectFilter = ({
  name,
  label,
  options = [],
  value = [],
  onChange,
  icon,
  sx,
}) => {
  const menuId = useId();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const selectedLabel = value.length ? `${label} (${value.length})` : label;

  const toggleOption = (optionValue) => {
    const nextValue = value.includes(optionValue)
      ? value.filter((selectedValue) => selectedValue !== optionValue)
      : [...value, optionValue];

    onChange({ target: { name, value: nextValue } });
  };

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={icon}
        endIcon={<KeyboardArrowDownIcon fontSize="small" />}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="menu"
        aria-expanded={open}
        sx={{ ...tableFilterButtonSx, ...sx }}
      >
        {selectedLabel}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{ "aria-label": label }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => toggleOption(option.value)}
          >
            <Checkbox
              size="small"
              checked={value.includes(option.value)}
              inputProps={{ "aria-label": option.label }}
            />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MultiSelectFilter;
